export default "__VITE_ASSET__Bd2Uy$Cy__"